import { Activity } from '@untitledui/icons';

import { useAgentFeed } from '@/lib/agent-feed/hooks/useAgentFeed';
import { cx } from '@/utils/cx';

interface AgentFeedRowProps {
  orgId: number | null;
  isSelected: boolean;
  onClick: () => void;
}

export default function AgentFeedRow({
  orgId,
  isSelected,
  onClick,
}: AgentFeedRowProps) {
  const { counts } = useAgentFeed(orgId);

  const evaluatingCount = counts.evaluating + counts.preparing;
  const doneTodayCount = counts.doneToday;

  return (
    <div
      onClick={onClick}
      role='button'
      tabIndex={0}
      aria-label='Agent Feed'
      data-testid='agent-feed-row'
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      className={cx(
        'relative flex items-center gap-2.5 border-t border-[var(--color-border-secondary)] px-4 py-3 cursor-pointer transition-colors',
        isSelected ? 'bg-bg-secondary' : 'bg-bg-primary hover:bg-bg-secondary'
      )}
    >
      <div className='flex-shrink-0 size-[26px] flex items-center justify-center rounded-full bg-[var(--color-bg-tertiary)]'>
        <Activity className='size-4 text-[var(--color-text-brand-secondary)]' />
      </div>
      <div className='flex-1 min-w-0'>
        <h3 className='font-semibold text-[14px] leading-5 text-[var(--color-text-primary)]'>
          Agent Feed
        </h3>
        <p className='text-[13px] leading-[18px] text-[var(--color-text-secondary)] truncate'>
          {evaluatingCount} evaluating · {doneTodayCount} done today
        </p>
      </div>
    </div>
  );
}
